/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, OnDestroy, Renderer2, inject } from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {ZIndexUtils} from "primeng/utils";

import { RightSideAnimationComponent } from './right-side-animation/right-side-animation.component';

@Component({
    selector: 'well-right-side',
    templateUrl: './right-side.component.html',
    styleUrls: ['./right-side.component.scss'],
    imports: [RouterOutlet, RightSideAnimationComponent]
})
export class RightSideComponent implements OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);


  constructor() {
    this.renderer.addClass(document.body, 'right-side-outlet');

  }

  public close(): void {
    this.router.navigate([{outlets: {'right-side': null}}], {
      queryParamsHandling: "preserve"
    });
  }

  ngOnInit(): void {
    ZIndexUtils.set('modal', this.elementRef.nativeElement, 1000);
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'right-side-outlet');

  }
}
